import { render } from "./BairroSelect.vue?vue&type=template&id=19c6b80c"
import script from "./BairroSelect.vue?vue&type=script&lang=js"
export * from "./BairroSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__